import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { ToastHostComponent } from "@features/+shared/notifications/toast-host/toast-host.component";
import { DO_INITIAL_LOGIN } from "@features/auth/store/auth.actions";
import { Store } from "@ngrx/store";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [RouterOutlet, ToastHostComponent],
})
export class AppComponent implements OnInit {
  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(DO_INITIAL_LOGIN());
  }
}
